export const SELECT_MODEL_FACTOR = 'SELECT_MODEL_FACTOR'

export const selectModelFactor = (modelFactorID) => ({
  type: SELECT_MODEL_FACTOR,
  payload: modelFactorID,
})

export const UPDATE_SELECTED_BASIC_PLAN = 'UPDATE_SELECTED_BASIC_PLAN'
export const updateSelectedBasicPlan = (basicPlanCode) => ({
  type: UPDATE_SELECTED_BASIC_PLAN,
  payload: basicPlanCode,
})

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})

export const VALIDATE_BASIC_PLAN = 'VALIDATE_BASIC_PLAN'
export const validateBasicPlan = () => ({ type: VALIDATE_BASIC_PLAN })
